<div class="row">
    <div class="col-sm-12">
        <h2 style="text-align: center;"> Interface </h2>
    </div>
</div>

<div class="row">

    <div [ngClass]="this.canImport ? 'col-sm-6' : 'col-sm-12'">
        <mat-card class="card card-initial" *ngIf="canGenerate" >
            <mat-card-header>
                <mat-card-title>Interface Sage</mat-card-title>

            </mat-card-header>
            <mat-card-content>
                <div class="button-row">

                    <mat-card class="sous-card" (click)="openInterface()">
                        <mat-card-content>

                            <div class="resume">
                                <mat-icon>import_export
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    Génération des fichiers
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div [ngClass]="this.canGenerate ? 'col-sm-6' : 'col-sm-12'">
        <mat-card class="card card-initial" *ngIf="canImport">
            <mat-card-header>
                <mat-card-title>Import</mat-card-title>

            </mat-card-header>
            <mat-card-content>
                <div class="button-row">

                    <mat-card class="sous-card" (click)="getBcToImport()">
                        <mat-card-content class="resume">

                            <mat-icon>import_export
                            </mat-icon>
                            <div class="vl"></div>
                            <span class="text">
                                Import BC
                            </span>
                        </mat-card-content>
                    </mat-card>
                </div>

            </mat-card-content>
        </mat-card>
    </div>

    <br>
</div>